document.addEventListener('DOMContentLoaded', function () {
  const stamps = document.querySelectorAll('.melt-stamp');

  stamps.forEach((stamp) => {
    const bubble = stamp.querySelector('.melt-stamp__bubble');
    if (!bubble) return;

    bubble.addEventListener('click', function (event) {
      if (window.innerWidth > 768) return;

      event.preventDefault();
      event.stopPropagation();

      stamps.forEach((item) => {
        if (item !== stamp) item.classList.remove('is-active');
      });

      stamp.classList.toggle('is-active');
    });
  });

  document.addEventListener('click', function () {
    if (window.innerWidth > 768) return;
    stamps.forEach((stamp) => stamp.classList.remove('is-active'));
  });
});